import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import JoinRibbon from '../../components/JoinRibbon'
import Navbar from '../../Layout/NavBar'
import "./contact.css"
import FlexibleGrid from '../../components/FlexibleGrid'
import { Button } from '@mui/material'
import FAQSection from '../LandingPage/FAQ_Section'
import TestimonialSection from '../LandingPage/testimonialSection/TestimonialSection'


function ContactDetail(){
    return(
        <div className='contact-detail-wp'>
          <p className='cn-line'>We’re excited to hear from you! Whether you have questions, need assistance, or want to share your feedback, our team is here to help.</p>  
           
<div className="form-wp">
  <form className="form">
    <div className="icon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 34" height="34" width="34">
        <path strokeLinejoin="round" strokeWidth="2.5" stroke="#115DFC" d="M7.08385 9.91666L5.3572 11.0677C4.11945 11.8929 3.50056 12.3055 3.16517 12.9347C2.82977 13.564 2.83226 14.3035 2.83722 15.7825C2.84322 17.5631 2.85976 19.3774 2.90559 21.2133C3.01431 25.569 3.06868 27.7468 4.67008 29.3482C6.27148 30.9498 8.47873 31.0049 12.8932 31.1152C15.6396 31.1838 18.3616 31.1838 21.1078 31.1152C25.5224 31.0049 27.7296 30.9498 29.331 29.3482C30.9324 27.7468 30.9868 25.569 31.0954 21.2133C31.1413 19.3774 31.1578 17.5631 31.1639 15.7825C31.1688 14.3035 31.1712 13.564 30.8359 12.9347C30.5004 12.3055 29.8816 11.8929 28.6437 11.0677L26.9171 9.91666"></path>
        <path strokeLinejoin="round" strokeWidth="2.5" stroke="#115DFC" d="M2.83331 14.1667L12.6268 20.0427C14.7574 21.3211 15.8227 21.9603 17 21.9603C18.1772 21.9603 19.2426 21.3211 21.3732 20.0427L31.1666 14.1667"></path>
        <path strokeWidth="2.5" stroke="#115DFC" d="M7.08331 17V8.50001C7.08331 5.82872 7.08331 4.49307 7.91318 3.66321C8.74304 2.83334 10.0787 2.83334 12.75 2.83334H21.25C23.9212 2.83334 25.2569 2.83334 26.0868 3.66321C26.9166 4.49307 26.9166 5.82872 26.9166 8.50001V17"></path>
        <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="2.5" stroke="#115DFC" d="M14.1667 14.1667H19.8334M14.1667 8.5H19.8334"></path>
      </svg>
    </div>
    <div className="note">
      <label className="title">We're here for you: Connect with us for any questions or concerns.</label>
      <span className="subtitle">For technical questions, please post your questions on our forum where you can get help from fellow students.</span>
    </div>
    <div className="note">
      <span className="subtitle">For course suggestions and career advice, check out our learning paths.</span>
    </div>
    <input placeholder="Enter your e-mail" title="Enter your e-mail" name="email" type="email" className="input_field" />
    <textarea className="input_field contact-msg" placeholder="Enter your message" title="Enter your message">

    </textarea>
    <button className="submit">Submit</button>
  </form>
</div>
            


        </div>
    )
    
}
function BookCall(){
    return(
        <div>
            <Link to={"https://wa.me/"+process.env.REACT_APP_CONTACT_NUM+"?text=Please book a call"}>
            <div className='call-box'>
            <img src='https://media.tenor.com/_wjh6GwPiU4AAAAi/whatsapp.gif' alt="call image" />
            <Button className='call-btn'>Message on WhatsApp</Button>
            </div>
            </Link>
            <div className='contact-detail-wp'>
                <div className='ct'>
                    <h4 className='topic'>Get in Touch</h4>
                    <p className='sub-topic'>For any inquiries, feel free to contact us via the methods below:</p>
                    <ul>
                        <li className='sub-topic'>Email: [contact@yourbusiness.com]</li>
                        <li className='sub-topic'>Phone: +91 60011 17920 [ Md Salehan ]</li>
                        <li className='sub-topic'>Address: Kolkata: Q-118/A/1 Salt Lake, Biswa Bangla Gate, Kol - 700266</li>
                        <li className='sub-topic'>Delhi: Paschimi Marg Vasant Vihar Delhi South, New Delhi, South Delhi</li>
                    </ul>
                    </div>

                    <div className='ct'>
                        <h4 className='topic'>Support Hours</h4>
                        <p className='sub-topic'>We’re available to assist you during the following times:</p>
                        <ul>
                            <li className='sub-topic'>Monday to Friday: 9:00 AM – 6:00 PM (IST)</li>
                            <li className='sub-topic'>Saturday: 10:00 AM – 2:00 PM (IST)</li>
                            <li className='sub-topic'>Sunday: Closed</li>
                            <li className='sub-topic'>Delhi: Paschimi Marg Vasant Vihar Delhi South, New Delhi, South Delhi</li>
                        </ul>
                    </div>

                    <div className='ct'>
                        <h4 className='topic'>We’re Here for You</h4>
                        <p className='sub-topic'>Your success is our priority! Don’t hesitate to reach out with any questions or concerns—we’ll do our best to get back to you promptly.</p>
                        
                    </div>
            </div>
        </div>
    )
    
}
function Contact() {
    const navigate = useNavigate()
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

  return (
    <div className='contact-page ct'>
    {/* <Button onClick={()=> navigate("/")} className='btn back au-bact'>
        <KeyboardReturnIcon className='back-icon'/>
    </Button> */}
        <Navbar type={1} />
        <div className='ct-content-wp'>
            <h1 className='header'>Contact Us</h1>
            
            
            <FlexibleGrid
        FirstBox={<ContactDetail />}
        SecondBox={<BookCall />}
        FirstBoxWidth={"70%"}
        SecondBoxWidth={"30%"}
         />
         

         

         

            
        </div>
        <FAQSection />
        <TestimonialSection />
        <JoinRibbon />
    </div>
  )
}

export default Contact